var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnlinepay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12916_33772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.20312 3.70508L9.7941 5.29605",
    stroke: "#00E58D",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7941 3.70508L8.20312 5.29605",
    stroke: "#00E58D",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8709 11.1344C8.20303 11.1344 8.47227 10.8651 8.47227 10.533C8.47227 10.2009 8.20303 9.93164 7.8709 9.93164C7.53877 9.93164 7.26953 10.2009 7.26953 10.533C7.26953 10.8651 7.53877 11.1344 7.8709 11.1344Z",
    fill: "#00E58D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8084 20.1344C30.1405 20.1344 30.4098 19.8651 30.4098 19.533C30.4098 19.2009 30.1405 18.9316 29.8084 18.9316C29.4763 18.9316 29.207 19.2009 29.207 19.533C29.207 19.8651 29.4763 20.1344 29.8084 20.1344Z",
    fill: "#00E58D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0625 17.3848V23.4819",
    stroke: "#00E58D",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61959 28.1254H1.81843C1.49587 28.1331 1.18344 28.0125 0.949772 27.79C0.716108 27.5675 0.580328 27.2613 0.572266 26.9388V16.3724C0.580328 16.0499 0.716079 15.7438 0.949696 15.5213C1.18331 15.2989 1.49569 15.1782 1.8182 15.1859H19.64",
    stroke: "#00E58D",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.556641 17.5016L23.0494 17.4219",
    stroke: "#00E58D",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0632 20.8125L0.570312 20.8922",
    stroke: "#00E58D",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83203 24.2425L6.76948 24.2285",
    stroke: "#00E58D",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83594 25.9301L9.02338 25.9082",
    stroke: "#00E58D",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.125 27.9809V27.4763C10.125 26.9025 10.353 26.3521 10.7587 25.9464C11.1645 25.5406 11.7148 25.3127 12.2887 25.3127H15.75C15.75 25.3127 16.875 22.5002 20.8125 23.0627C24.3351 23.5659 24.2561 24.5195 27.4224 24.7147",
    stroke: "#00E58D",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.125 27L16.3125 28.125H4.28496C4.04362 28.125 3.81217 28.2209 3.64152 28.3915C3.47087 28.5622 3.375 28.7936 3.375 29.035C3.375 29.2517 3.45236 29.4613 3.59316 29.6261C3.73396 29.7909 3.92895 29.9 4.14304 29.9338L14.0625 31.5L22.5 29.8125L27.5023 31.1768",
    stroke: "#00E58D",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8125 26.4375C30.1232 26.4375 30.375 26.1857 30.375 25.875C30.375 25.5643 30.1232 25.3125 29.8125 25.3125C29.5018 25.3125 29.25 25.5643 29.25 25.875C29.25 26.1857 29.5018 26.4375 29.8125 26.4375Z",
    fill: "#00E58D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4375 23.625H27.5625V32.625H32.0625V23.8089",
    stroke: "#00E58D",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0625 31.4996V23.8086",
    stroke: "#00E58D",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4375 31.5H32.0625",
    stroke: "#00E58D",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1875 17.4375C27.2941 17.4375 29.8125 14.9191 29.8125 11.8125C29.8125 8.7059 27.2941 6.1875 24.1875 6.1875C21.0809 6.1875 18.5625 8.7059 18.5625 11.8125C18.5625 14.9191 21.0809 17.4375 24.1875 17.4375Z",
    stroke: "#00E58D",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4375 9L21.9375 14.625",
    stroke: "#00E58D",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2188 10.6875C22.6847 10.6875 23.0625 10.3097 23.0625 9.84375C23.0625 9.37776 22.6847 9 22.2188 9C21.7528 9 21.375 9.37776 21.375 9.84375C21.375 10.3097 21.7528 10.6875 22.2188 10.6875Z",
    stroke: "#00E58D",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1562 14.625C26.6222 14.625 27 14.2472 27 13.7812C27 13.3153 26.6222 12.9375 26.1562 12.9375C25.6903 12.9375 25.3125 13.3153 25.3125 13.7812C25.3125 14.2472 25.6903 14.625 26.1562 14.625Z",
    stroke: "#00E58D",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12916_33772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlinepay);
export default __webpack_public_path__ + "static/media/onlinepay.cc313145d845715f92cd8b7cc46b47a3.svg";
export { ForwardRef as ReactComponent };